import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import actions from '../constants';

const useShowDataModelReports = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ name }) => handler({
    type: actions.SHOW_DATA_MODEL_REPORTS, category, code, name,
  }), [category, code]);
};

const useShowDictionaryReports = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ name, reportType }) => handler({
    type: actions.SHOW_DICTIONARY_REPORTS,
    category,
    code,
    name,
    reportType,
  }), [category, code]);
};

export default {
  useShowDataModelReports,
  useShowDictionaryReports,
};
